var _path, _path2, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5004 14.9237C11.2027 14.9237 8.52938 12.2504 8.52938 8.95267C8.52938 5.65496 11.2027 2.98163 14.5004 2.98163C17.7981 2.98163 20.4715 5.65496 20.4715 8.95267C20.4715 12.2504 17.7981 14.9237 14.5004 14.9237ZM25.2477 25.6716V23.2832C25.2477 19.9855 22.5744 17.3121 19.2767 17.3121H9.723C6.42528 17.3121 3.75195 19.9855 3.75195 23.2832V25.6716C3.75195 26.3312 4.28662 26.8658 4.94616 26.8658C5.60571 26.8658 6.14037 26.3312 6.14037 25.6716V23.2832C6.14037 21.3046 7.74437 19.7006 9.723 19.7006H19.2767C21.2553 19.7006 22.8593 21.3046 22.8593 23.2832V25.6716C22.8593 26.3312 23.394 26.8658 24.0535 26.8658C24.713 26.8658 25.2477 26.3312 25.2477 25.6716ZM18.0832 8.95274C18.0832 10.9314 16.4792 12.5354 14.5006 12.5354C12.522 12.5354 10.918 10.9314 10.918 8.95274C10.918 6.97411 12.522 5.37012 14.5006 5.37012C16.4792 5.37012 18.0832 6.97411 18.0832 8.95274Z",
    fill: "#464646"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_698_12574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 23,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5004 14.9237C11.2027 14.9237 8.52938 12.2504 8.52938 8.95267C8.52938 5.65496 11.2027 2.98163 14.5004 2.98163C17.7981 2.98163 20.4715 5.65496 20.4715 8.95267C20.4715 12.2504 17.7981 14.9237 14.5004 14.9237ZM25.2477 25.6716V23.2832C25.2477 19.9855 22.5744 17.3121 19.2767 17.3121H9.723C6.42528 17.3121 3.75195 19.9855 3.75195 23.2832V25.6716C3.75195 26.3312 4.28662 26.8658 4.94616 26.8658C5.60571 26.8658 6.14037 26.3312 6.14037 25.6716V23.2832C6.14037 21.3046 7.74437 19.7006 9.723 19.7006H19.2767C21.2553 19.7006 22.8593 21.3046 22.8593 23.2832V25.6716C22.8593 26.3312 23.394 26.8658 24.0535 26.8658C24.713 26.8658 25.2477 26.3312 25.2477 25.6716ZM18.0832 8.95274C18.0832 10.9314 16.4792 12.5354 14.5006 12.5354C12.522 12.5354 10.918 10.9314 10.918 8.95274C10.918 6.97411 12.522 5.37012 14.5006 5.37012C16.4792 5.37012 18.0832 6.97411 18.0832 8.95274Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_698_12574)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.661,
    height: 28.661,
    transform: "translate(0.169922 0.593201)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.169922,
    y: 0.593201,
    width: 28.661,
    height: 28.661,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_698_12574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 30
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.169922,
    y: 0.593201,
    width: 28.661,
    height: 28.661,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_698_12574)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.169922,
    y: 0.593201,
    width: 28.661,
    height: 28.661,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.28026c2e7c91cd549ef73b850a721f43.svg";
export { ForwardRef as ReactComponent };